import { collectionGroup, getDocs, query, where } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { ModuleWithPagePath } from "../types";
import { ModuleDB } from "./Modules";

export const getPageModulesByTagId = async (tagId: string) => {
  try {
    const modulesQuery = query(
      collectionGroup(db, "modules"),
      where("tags", "array-contains", tagId),
    );

    const querySnapshot = await getDocs(modulesQuery);
    const modules: ModuleWithPagePath[] = [];

    querySnapshot.forEach((doc) => {
      const moduleData = new ModuleDB(doc).toModule();
      const redirectionPath = `/${doc.ref.path.split("/").slice(0, -2).join("/")}`;

      modules.push({
        ...moduleData,
        redirectionPath,
      });
    });

    return modules;
  } catch (e) {
    console.error(e);
    return [];
  }
};
